import React, { useState } from "react";
import { Table, Button, Card} from "reactstrap";
import { AddNewButton, EditDeleteButtons, Page, PendingButton } from "components/common";
import { useTable } from "hooks";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { HolidayStatus } from "components";
import { exportDownload } from "services/util";

const ToReview = ({ url, match, client, onApproved, t }) => {
  const {
    TableContainer,
    data,
    PayrollTableDataFetch,
    BulkDeleteButton,
    onDeleteItem,
    refreshData,
  } = useTable({
    url,
    filters: {
      awaiting_review: true,
    },
    limit: 20,
  });



  return (
    <>
      <PayrollTableDataFetch className="inv-table" />
      
        <hr />
        <div className="d-flex justify-content-between mb-2">
          <h4 className="font-weight-light">
            <Trans>To review</Trans>
          </h4>
          <BulkDeleteButton
            className="d-none"
            prefix="payroll"
            organisation_data={data?.results[0]}
          />
        </div> 
          <TableContainer>
            <Table>
              <thead>
                <tr>
                  <th sortBy="employee__first_name">
                    <Trans>Employee</Trans>
                  </th>
                  <th sortBy="starting">
                    <Trans>Starting</Trans>
                  </th>
                  <th sortBy="ending">
                    <Trans>Ending</Trans>
                  </th>
                  <th>
                    <Trans>Type</Trans>
                  </th>
                  <th sortBy="replacement_employee__first_name">
                    <Trans>Replacement</Trans>
                  </th>
                  <th><Trans>Approval</Trans></th>
                  <th><Trans>Actions</Trans></th>
                </tr>
              </thead>
              <tbody>
              {data?.results?.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <Link to={`/payroll/time_off/${item.id}`}>
                        {item.employee__full_name}
                      </Link>
                    </td>
                    <td>
                      {item.starting} <Trans>{item.starting_time}</Trans>
                    </td>
                    <td>
                      {item.ending} <Trans>{item.ending_time}</Trans>
                    </td>
                    <td>{item.type}</td>
                    <td>
                      <Link to={`/payroll/employees/${item.replacement_employee}`}>
                        {item.replacement_employee__full_name}
                      </Link>
                    </td>
                    <td>
                        <Link to={`time_off/${item.id}`} outline className="mr-2 btn btn-sm btn-outline-success nrml"><Trans>Approve</Trans></Link>
                        <Link to={`time_off/${item.id}`} outline className="mr-2 btn btn-sm btn-outline-danger nrml"><Trans>Reject</Trans></Link>
                    </td>
                    <td>
                      <EditDeleteButtons url={match.url} id={item.id} onDelete={onDeleteItem} />
                    </td>
                  </tr>
                ))
              }
              </tbody>
          </Table>
          </TableContainer>
    </>
  );
};

export const Holidays = ({ match, url = "employee_holidays", t, payroll }) => {
  const [upcoming, setUpcoming] = useState(true);
  const {
    TableContainer,
    data,
    onDeleteItem,
    PayrollTableDataFetch,
    BulkDeleteButton,
    TableSearch,
    mergeFilters,
    ViewingRecords,
    Pagination,
    refreshData,
  } = useTable({
    url,
    filters: {
      upcoming,
    },
  });

  if (!data) return null;

  return (
    <Page>
      <div className="d-flex justify-content-between align-items-center">
        <TableSearch className="my-0 flex-grow-1 mr-3" />
        <AddNewButton size="sm" resource="Time off" match={match} />
        <Button size="md" color="primary" onClick={()=>{exportDownload(payroll, "employee_holidays/export", 'time_offs.xlsx')}}>
          <Trans>Export <span className="mx-1" /><i className="fas fa-file-excel" /> </Trans>
        </Button>
      </div>
      <ToReview url={url} match={match} client={payroll} onApproved={refreshData} t={t} />
      <BulkDeleteButton className="d-none" prefix="payroll" organisation_data={data.results[0]} />
      <hr />
      <div className="d-flex mb-2 align-items-start">
        <h4 className="font-weight-light">
          <Trans>{upcoming ? "Upcoming" : "History"}</Trans>
        </h4>
        <div className="mx-auto" />
        <PendingButton
          color="link"
          className="p-0"
          onClick={() => {
            setUpcoming(!upcoming);
            mergeFilters({ upcoming: !upcoming });
          }}
        >
          View {upcoming ? "History" : "Current"}
        </PendingButton>
      </div>
      <TableContainer>
        <Table responsive>
          <thead>
            <tr>
              <th sortBy="employee__first_name" className="text-nowrap">
                <Trans>Employee</Trans>
              </th>
              <th sortBy="starting" className="text-nowrap">
                <Trans>Starting</Trans>
              </th>
              <th sortBy="ending" className="text-nowrap">
                <Trans>Ending</Trans>
              </th>
              <th sortBy="type" className="text-nowrap">
                <Trans>Type</Trans>
              </th>
              <th sortBy="replacement_employee__first_name" className="text-nowrap">
                <Trans>Replacement</Trans>
              </th>
              <th>
                <Trans>Status</Trans>
              </th>
              {upcoming && (
                <th>
                  <Trans>Action</Trans>
                </th>)}
            </tr>
          </thead>
          <tbody>
            {data?.results?.length > 0 ? data.results.map((i) => (
              <tr key={i.id}>
                <td>
                  <Link to={`/payroll/time_off/${i.id}`} className="link">
                    {i.employee__full_name}
                  </Link>
                </td>
                <td>
                  {i.starting} <Trans>{i.starting_time}</Trans>
                </td>
                <td>
                  {i.ending} <Trans>{i.ending_time}</Trans>
                </td>
                <td>{i.type}</td>
                <td>
                  <Link to={`/payroll/employees/${i.replacement_employee}`}>
                    {i.replacement_employee__full_name}
                  </Link>
                </td>
                <td>
                  {(
                    <HolidayStatus approved={i.approved} />
                  )}
                </td>

                {upcoming && (
                  <td className="text-end text-nowrap">
                    <EditDeleteButtons
                      url={match.url}
                      id={i.id}
                      onDelete={onDeleteItem}
                      showDelete={!i.approved}
                    />
                  </td>
                )}
              </tr>
            ))
            :
              <tr>
                <td colSpan="7" className="text-center">
                  <Trans>No records found</Trans>
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </TableContainer>
      <PayrollTableDataFetch />
      <div className="d-flex justify-content-between">
        <div className=""><ViewingRecords noCount /></div>
        <div className=""><Pagination /></div>
      </div>
    </Page>
  );
};

export default Holidays;
